import { FC } from 'react'
import { AppHead } from 'client/components/ProfileLayout/components/AppHead/AppHead'
import { ProfilePageContent } from 'client/contents/ProfileContent/ProfileContent'
import { ProfileLayout } from 'client/components/ProfileLayout/ProfileLayout'

type TProps = {}

const ProfilePage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <ProfilePageContent />
    </article>
  )
}

// @ts-ignore
ProfilePage.layout = (page) => <ProfileLayout children={page}></ProfileLayout>

export default ProfilePage
